import React, { useEffect } from 'react';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import AuthLayoutBackground from '../components/AuthLayoutBackground';
import { LegacyButton } from 'apps/sigma2-ui/src/components/ui/LegacyButton';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { useAuthenticatedPageRedirect } from 'apps/sigma2-ui/src/lib/hooks/useAuthenticatedPageRedirect';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { uiEnvironment } from 'apps/sigma2-ui/src/constants/environment';

export const WelcomePage = () => {
  const { myUser, myUserStatus, startLoggingOut } = useUser();
  const language = useLanguage();
  useAuthenticatedPageRedirect();
  const navigate = useNavigateSafe();

  useEffect(() => {
    if (myUserStatus !== 'logged_in' || !myUser || !myUser.organization) {
      return;
    }

    if (myUser.organization.hasDataAvailable) {
      navigate('/overview');
      return;
    }

    if (myUser.organization.role === 'admin') {
      navigate('/upload');
      return;
    }
  }, [myUser, myUserStatus, navigate]);

  if (myUserStatus !== 'logged_in') {
    return <></>;
  }

  return (
    <main className="w-screen h-screen bg-blue-1000 overflow-hidden relative">
      <div
        className="absolute"
        style={{ width: 1824, transform: 'translate(-18vw, 5vh)' }}
      >
        <AuthLayoutBackground />
      </div>
      <div>
        <div className="relative z-standout flex flex-col h-screen">
          <div className="absolute flex w-screen justify-end p-10">
            <LegacyButton
              onClick={() => {
                startLoggingOut(uiEnvironment.callbackLogoutUri);
              }}
              className="text-sm"
              variant={LegacyButtonVariant.PRIMARY_DARK}
            >
              {language.logOut()}
            </LegacyButton>
          </div>
          <div className="flex-grow flex flex-col justify-center">
            <div className="max-w-content min-w-content w-full mx-auto flex flex-col pl-20 pr-20">
              <div className="w-full">
                <div className="text-left text-gray-100 text-base">
                  <p className=" text-xl font-sans">
                    {language.welcomeTitle()}
                  </p>
                  <p className="text-base font-sans mt-3 mb-3">
                    {language.welcomeBlurb()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
